if ("todesktop" in window) {
  import("../platforms/desktop_app")
}
